<app-navbar title="Plik Sezon">
	<button (click)="openPlaneImportDialog()" class="me-2" mat-raised-button color="primary">
		Importuj terminy samolotowe <i class="fa-solid fa-file-import"></i>
	</button>

	<button
		class="me-2 term-action-button"
		mat-raised-button
		color="primary"
		cdkFocusInitial
		(click)="goToTransport(TransportSide.DEPARTURE)"
	>
		Wyjazd
	</button>

	<button
		class="me-2 term-action-button"
		mat-raised-button
		color="primary"
		cdkFocusInitial
		(click)="goToTransport(TransportSide.RETURN)"
	>
		Powrót
	</button>

	<button class="me-2" mat-raised-button color="primary" (click)="linkComfortPackagePool()">
		Połącz pulę Komfort <i class="fa-solid fa-couch"></i>
	</button>

	<button class="me-2" mat-raised-button color="primary" (click)="unlinkComfortPackagePool()">
		Rozłącz pulę Komfort <i class="fa-solid fa-link-slash"></i>
	</button>
</app-navbar>
@if (responsibleUserHasChanged()) {
	<div class="alert alert-warning m-3 text-center" role="alert">
		Zmieniono osobę odpowiedzialną, aby zobaczyć zmiany odśwież stronę!
	</div>
}
<div class="row filters-row m-2">
	<div class="col-md-10">
		<input [(ngModel)]="search" type="text" class="form-control w-100" placeholder="Filtrowanie (min. 3 znaki)" />
	</div>
	<div class="col-md-2 text-center">
		<button class="me-4" mat-raised-button color="primary" (click)="filtersOpen()">
			<i class="fas fa-filter"></i>
		</button>
	</div>
</div>

<app-bag-transport-filters
	userFilters="season_bag_new"
	[yesno]="parameters.yesno"
	[names]="parameters.names"
	[statuses]="parameters.statuses"
	[allUsers]="parameters.allUsers"
	[filters]="filters"
	(selected)="filtersSelected($event)"
	[forceFilters]="{ limit: 9999 }"
>
</app-bag-transport-filters>

<app-bag-transport-term-table
	[parameters]="parameters"
	(pageChange)="pageChanged($event)"
	(deadlineChanged)="deadlineChanged()"
	[page]="page()"
	[allItemsSize]="allItemsSize()"
	[isLoading]="isLoading()"
	(sortedByColumn)="setSorting($event)"
	(responsibleUserHasChanged)="responsibleUserHasChanged.set($event)"
></app-bag-transport-term-table>
